/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown> }} Audit_Action_LabelInputs */

const en_audit_action_label = /** @type {(inputs: Audit_Action_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.action === "USER_LOGIN") return /** @type {LocalizedString} */ (`User login`);
	if (i?.action === "CASE_CREATED") return /** @type {LocalizedString} */ (`Case created`);
	if (i?.action === "CASE_VIEWED") return /** @type {LocalizedString} */ (`Case viewed`);
	if (i?.action === "CASE_UPDATED") return /** @type {LocalizedString} */ (`Case updated`);
	if (i?.action === "CASE_STEP_CHANGED") return /** @type {LocalizedString} */ (`Case step changed`);
	if (i?.action === "CASE_DELETED") return /** @type {LocalizedString} */ (`Case deleted`);
	if (i?.action === "CLIENT_CREATED") return /** @type {LocalizedString} */ (`Client created`);
	if (i?.action === "CLIENT_VIEWED") return /** @type {LocalizedString} */ (`Client viewed`);
	if (i?.action === "CLIENT_UPDATED") return /** @type {LocalizedString} */ (`Client updated`);
	if (i?.action === "CLIENT_DELETED") return /** @type {LocalizedString} */ (`Client deleted`);
	if (i?.action === "BRANCH_CREATED") return /** @type {LocalizedString} */ (`Branch created`);
	if (i?.action === "BRANCH_UPDATED") return /** @type {LocalizedString} */ (`Branch updated`);
	if (i?.action === "BRANCH_ARCHIVED") return /** @type {LocalizedString} */ (`Branch archived`);
	if (i?.action === "TASK_CREATED") return /** @type {LocalizedString} */ (`Task created`);
	if (i?.action === "TASK_VIEWED") return /** @type {LocalizedString} */ (`Task viewed`);
	if (i?.action === "TASK_UPDATED") return /** @type {LocalizedString} */ (`Task updated`);
	if (i?.action === "DOCUMENT_UPLOAD_INITIATED") return /** @type {LocalizedString} */ (`Document upload initiated`);
	if (i?.action === "DOCUMENT_DELETED") return /** @type {LocalizedString} */ (`Document deleted`);
	if (i?.action === "DOCUMENT_CLASSIFICATION_OVERRIDDEN") return /** @type {LocalizedString} */ (`Document classification overridden`);
	if (i?.action === "USER_CREATED") return /** @type {LocalizedString} */ (`User created`);
	if (i?.action === "USER_VIEWED") return /** @type {LocalizedString} */ (`User viewed`);
	if (i?.action === "USER_DISABLED") return /** @type {LocalizedString} */ (`User disabled`);
	if (i?.action === "USER_ENABLED") return /** @type {LocalizedString} */ (`User enabled`);
	if (i?.action === "USER_INVITATION_RESENT") return /** @type {LocalizedString} */ (`User invitation resent`);
	if (i?.action === "USER_SIGNED_OUT") return /** @type {LocalizedString} */ (`User signed out`);
	if (i?.action === "USER_GROUPS_UPDATED") return /** @type {LocalizedString} */ (`User groups updated`);
	if (i?.action === "USER_PROFILE_VIEWED") return /** @type {LocalizedString} */ (`User profile viewed`);
	if (i?.action === "USER_PROFILE_UPDATED") return /** @type {LocalizedString} */ (`User profile updated`);
	if (i?.action === "PROFILE_UPDATED") return /** @type {LocalizedString} */ (`Profile updated`);
	if (i?.action === "AUTOMATION_RUN_RETRIED") return /** @type {LocalizedString} */ (`Flow run retried`);
	if (i?.action === "AUTOMATION_ASSIGNEE_SLOT_UPDATED") return /** @type {LocalizedString} */ (`Flow assignee slot updated`);
	if (i?.action === "TASK_SETTINGS_UPDATED") return /** @type {LocalizedString} */ (`Activity settings updated`);
	if (i?.action === "TASK_FLOW_UPDATED") return /** @type {LocalizedString} */ (`Activity flow updated`);
	if (i?.action === "TASK_TYPE_UPDATED") return /** @type {LocalizedString} */ (`Activity updated`);
	if (i?.action === "TASK_DEFINITION_UPDATED") return /** @type {LocalizedString} */ (`Activity configuration updated`);
	if (i?.action === "TASK_DEFINITION_DELETED") return /** @type {LocalizedString} */ (`Activity removed from case type`);
	return /** @type {LocalizedString} */ (`${i?.action}`)
	
};

const pt_br2_audit_action_label = /** @type {(inputs: Audit_Action_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.action === "USER_LOGIN") return /** @type {LocalizedString} */ (`Login do usuário`);
	if (i?.action === "CASE_CREATED") return /** @type {LocalizedString} */ (`Caso criado`);
	if (i?.action === "CASE_VIEWED") return /** @type {LocalizedString} */ (`Caso visualizado`);
	if (i?.action === "CASE_UPDATED") return /** @type {LocalizedString} */ (`Caso atualizado`);
	if (i?.action === "CASE_STEP_CHANGED") return /** @type {LocalizedString} */ (`Etapa do caso alterada`);
	if (i?.action === "CASE_DELETED") return /** @type {LocalizedString} */ (`Caso excluído`);
	if (i?.action === "CLIENT_CREATED") return /** @type {LocalizedString} */ (`Cliente criado`);
	if (i?.action === "CLIENT_VIEWED") return /** @type {LocalizedString} */ (`Cliente visualizado`);
	if (i?.action === "CLIENT_UPDATED") return /** @type {LocalizedString} */ (`Cliente atualizado`);
	if (i?.action === "CLIENT_DELETED") return /** @type {LocalizedString} */ (`Cliente excluído`);
	if (i?.action === "BRANCH_CREATED") return /** @type {LocalizedString} */ (`Filial criada`);
	if (i?.action === "BRANCH_UPDATED") return /** @type {LocalizedString} */ (`Filial atualizada`);
	if (i?.action === "BRANCH_ARCHIVED") return /** @type {LocalizedString} */ (`Filial arquivada`);
	if (i?.action === "TASK_CREATED") return /** @type {LocalizedString} */ (`Atividade criada`);
	if (i?.action === "TASK_VIEWED") return /** @type {LocalizedString} */ (`Atividade visualizada`);
	if (i?.action === "TASK_UPDATED") return /** @type {LocalizedString} */ (`Atividade atualizada`);
	if (i?.action === "DOCUMENT_UPLOAD_INITIATED") return /** @type {LocalizedString} */ (`Upload de documento iniciado`);
	if (i?.action === "DOCUMENT_DELETED") return /** @type {LocalizedString} */ (`Documento excluído`);
	if (i?.action === "DOCUMENT_CLASSIFICATION_OVERRIDDEN") return /** @type {LocalizedString} */ (`Classificação do documento substituída`);
	if (i?.action === "USER_CREATED") return /** @type {LocalizedString} */ (`Usuário criado`);
	if (i?.action === "USER_VIEWED") return /** @type {LocalizedString} */ (`Usuário visualizado`);
	if (i?.action === "USER_DISABLED") return /** @type {LocalizedString} */ (`Usuário desativado`);
	if (i?.action === "USER_ENABLED") return /** @type {LocalizedString} */ (`Usuário ativado`);
	if (i?.action === "USER_INVITATION_RESENT") return /** @type {LocalizedString} */ (`Convite do usuário reenviado`);
	if (i?.action === "USER_SIGNED_OUT") return /** @type {LocalizedString} */ (`Usuário saiu`);
	if (i?.action === "USER_GROUPS_UPDATED") return /** @type {LocalizedString} */ (`Grupos do usuário atualizados`);
	if (i?.action === "USER_PROFILE_VIEWED") return /** @type {LocalizedString} */ (`Perfil de usuário visualizado`);
	if (i?.action === "USER_PROFILE_UPDATED") return /** @type {LocalizedString} */ (`Perfil de usuário atualizado`);
	if (i?.action === "PROFILE_UPDATED") return /** @type {LocalizedString} */ (`Perfil atualizado`);
	if (i?.action === "AUTOMATION_RUN_RETRIED") return /** @type {LocalizedString} */ (`Execução de fluxo reenviada`);
	if (i?.action === "AUTOMATION_ASSIGNEE_SLOT_UPDATED") return /** @type {LocalizedString} */ (`Responsável de fluxo atualizado`);
	if (i?.action === "TASK_SETTINGS_UPDATED") return /** @type {LocalizedString} */ (`Configurações de atividade atualizadas`);
	if (i?.action === "TASK_FLOW_UPDATED") return /** @type {LocalizedString} */ (`Fluxo de atividade atualizado`);
	if (i?.action === "TASK_TYPE_UPDATED") return /** @type {LocalizedString} */ (`Atividade atualizada`);
	if (i?.action === "TASK_DEFINITION_UPDATED") return /** @type {LocalizedString} */ (`Configuração de atividade atualizada`);
	if (i?.action === "TASK_DEFINITION_DELETED") return /** @type {LocalizedString} */ (`Atividade removida do tipo de caso`);
	return /** @type {LocalizedString} */ (`${i?.action}`)
	
};

/**
* | action | output |
* | --- | --- |
* | "USER_LOGIN" | "User login" |
* | "CASE_CREATED" | "Case created" |
* | "CASE_VIEWED" | "Case viewed" |
* | "CASE_UPDATED" | "Case updated" |
* | "CASE_STEP_CHANGED" | "Case step changed" |
* | "CASE_DELETED" | "Case deleted" |
* | "CLIENT_CREATED" | "Client created" |
* | "CLIENT_VIEWED" | "Client viewed" |
* | "CLIENT_UPDATED" | "Client updated" |
* | "CLIENT_DELETED" | "Client deleted" |
* | "BRANCH_CREATED" | "Branch created" |
* | "BRANCH_UPDATED" | "Branch updated" |
* | "BRANCH_ARCHIVED" | "Branch archived" |
* | "TASK_CREATED" | "Task created" |
* | "TASK_VIEWED" | "Task viewed" |
* | "TASK_UPDATED" | "Task updated" |
* | "DOCUMENT_UPLOAD_INITIATED" | "Document upload initiated" |
* | "DOCUMENT_DELETED" | "Document deleted" |
* | "DOCUMENT_CLASSIFICATION_OVERRIDDEN" | "Document classification overridden" |
* | "USER_CREATED" | "User created" |
* | "USER_VIEWED" | "User viewed" |
* | "USER_DISABLED" | "User disabled" |
* | "USER_ENABLED" | "User enabled" |
* | "USER_INVITATION_RESENT" | "User invitation resent" |
* | "USER_SIGNED_OUT" | "User signed out" |
* | "USER_GROUPS_UPDATED" | "User groups updated" |
* | "USER_PROFILE_VIEWED" | "User profile viewed" |
* | "USER_PROFILE_UPDATED" | "User profile updated" |
* | "PROFILE_UPDATED" | "Profile updated" |
* | "AUTOMATION_RUN_RETRIED" | "Flow run retried" |
* | "AUTOMATION_ASSIGNEE_SLOT_UPDATED" | "Flow assignee slot updated" |
* | "TASK_SETTINGS_UPDATED" | "Activity settings updated" |
* | "TASK_FLOW_UPDATED" | "Activity flow updated" |
* | "TASK_TYPE_UPDATED" | "Activity updated" |
* | "TASK_DEFINITION_UPDATED" | "Activity configuration updated" |
* | "TASK_DEFINITION_DELETED" | "Activity removed from case type" |
* | * | "{action}" |
*
* @param {Audit_Action_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_action_label = /** @type {((inputs: Audit_Action_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Action_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_action_label(inputs)
	return pt_br2_audit_action_label(inputs)
});